export default __webpack_public_path__ + "static/ogram-logo-7a2f3a2cdc92b89251a8a1c8b0fae15c.svg";